import { type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { i18n } from '@wms/shared';
import { api } from '../lib/api.js';

const { t } = i18n;

export function PasswordResetRequestPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api('/auth/password-reset/request', { method: 'POST', body: { email } });
    } catch {
      // Always present "submitted" — endpoint always 204s on its own.
    } finally {
      setBusy(false);
      setSubmitted(true);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm space-y-4 rounded-lg border border-border p-6">
        <h1 className="text-lg font-semibold">{t('auth.password_reset.title')}</h1>
        {submitted ? (
          <>
            <p className="text-sm text-muted-foreground">{t('auth.password_reset.submitted')}</p>
            <Link to="/login" className="block text-sm text-primary hover:underline">
              ← {t('auth.login.title')}
            </Link>
          </>
        ) : (
          <form onSubmit={(e) => void onSubmit(e)} className="space-y-3">
            <label className="block space-y-1">
              <span className="text-sm">{t('auth.password_reset.email')}</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded border border-border bg-background px-2 py-1.5 text-sm"
              />
            </label>
            <button
              type="submit"
              disabled={busy || !email}
              className="w-full rounded bg-primary text-primary-foreground py-1.5 text-sm font-medium disabled:opacity-50"
            >
              {busy ? t('common.loading') : t('auth.password_reset.request_submit')}
            </button>
            <Link to="/login" className="block text-xs text-muted-foreground hover:underline">
              ← {t('auth.login.title')}
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
